import { render, staticRenderFns } from "./opintoopas-form.vue?vue&type=template&id=119cde58&scoped=true&"
import script from "./opintoopas-form.vue?vue&type=script&lang=ts&"
export * from "./opintoopas-form.vue?vue&type=script&lang=ts&"
import style0 from "./opintoopas-form.vue?vue&type=style&index=0&id=119cde58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119cde58",
  null
  
)

export default component.exports